import { get } from "../utility/fetch-util";

/**
 *  Get leasing company information from customer services (go via drivers rest web services as csc module may not be present)
 */
export const getCscCompanyGroupConfig = async (progress) => {
    return get('/api/drivers/csc/config/co-group', null, progress);
}

/**
 *  Get customer profile from customer services (go via drivers rest web services as csc module may not be present)
 */
export const getCscCustomerProfile = async (entityId, type, customerCode, progress) => {
    return get('/api/drivers/csc/config/customer/entity/' + entityId + '/type/' + type + '/code/' + customerCode, null, progress);
}

